import Cookies from 'js-cookie';

import { CONSENT_COOKIES_KEYS } from '../../../constants';

const REGIONS_DENY_DEFAULT = [
  'AT',
  'BE',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'ES',
  'SE',
  'GB',
  'US-CA',
];

function init() {
  console.log('GA4 init');

  const GA4PropertyId =
    ENVIRONMENT === 'production' ? 'G-8V4J1MY5HV' : 'G-R767G5RSGD';
  const googleAdsMeasurementIds =
    ENVIRONMENT === 'production' ? ['AW-974107230', 'AW-979459470'] : [];
  const firstPartyTagging = `, {
    "transport_url": "https://tag.withlocals.com",
    "first_party_collection": true,
    }`;

  console.log('GA4PropertyId', GA4PropertyId);

  const gtagScriptElement = document.createElement('script');
  gtagScriptElement.src = `https://www.googletagmanager.com/gtag/js?id=${GA4PropertyId}&l=ga4Layer`;
  gtagScriptElement.async = true;
  document.head.appendChild(gtagScriptElement);

  const advertisementCookie = Cookies.get(CONSENT_COOKIES_KEYS.ADVERTISEMENT);
  const personalizationCookie = Cookies.get(
    CONSENT_COOKIES_KEYS.PERSONALISED_ADS,
  );
  const analyticsCookie = Cookies.get(CONSENT_COOKIES_KEYS.ANALYTICS);

  const updateObject = Object.assign({});
  if (advertisementCookie && personalizationCookie) {
    updateObject.ad_storage =
      advertisementCookie === 'true' || personalizationCookie === 'true'
        ? 'granted'
        : 'denied';
  }

  if (analyticsCookie) {
    updateObject.analytics_storage =
      analyticsCookie === 'true' ? 'granted' : 'denied';
  }

  if (advertisementCookie) {
    updateObject.ad_user_data =
      advertisementCookie === 'true' ? 'granted' : 'denied';
  }

  if (personalizationCookie) {
    updateObject.ad_personalization =
      personalizationCookie === 'true' ? 'granted' : 'denied';
  }

  const gtagSetupScriptElement = document.createElement('script');
  gtagSetupScriptElement.innerHTML = `
      window.ga4Layer = window.ga4Layer || [];
      function ga4Tag() { ga4Layer.push(arguments); }
      ga4Tag('js', new Date());
      ga4Tag('config', '${GA4PropertyId}'${
        ENVIRONMENT === 'production' ? firstPartyTagging : ''
      });
      ${googleAdsMeasurementIds
        .map((id) => `ga4Tag('config', '${id}')`)
        .join(';')}
      ga4Tag('consent', 'default', {
        'analytics_storage': 'granted',
        'ad_storage': 'granted',
        'ad_user_data': 'granted',
        'ad_personalization': 'granted',
      });
      ga4Tag('consent', 'default', {
        'analytics_storage': 'denied',
        'ad_storage': 'denied',
        'ad_user_data': 'denied',
        'ad_personalization': 'denied',
        'region': ${JSON.stringify(REGIONS_DENY_DEFAULT)}
      });
      ga4Tag("consent", "update", ${JSON.stringify(updateObject)});
  `;
  document.head.appendChild(gtagSetupScriptElement);
}

export default {
  init,
};
